import { CategoryBlockBackgroundImage } from './CategoryBlockBackgroundImage';
import {
  BLOCK_SIZES_DESKTOP,
  BLOCK_SIZES_MOBILE,
  BLOCK_WIDTHS_DESKTOP,
  BLOCK_WIDTHS_MOBILE,
} from './constants';

interface CarouselBackgroundProps {
  /** Raw image source; this component sizes it. */
  src: string;
  /** Which branch the block is rendering, from `useGlobal`. */
  isMobile: boolean;
  /** Ratio of the box the mobile branch reserves. */
  mobileAspectRatio: number;
  /** Ratio of the box the desktop branch reserves. */
  desktopAspectRatio: number;
  priority?: boolean;
}

/**
 * Background layer for the product carousels, which render a different
 * component per branch and so need only the variant for the branch they are in.
 *
 * A `<picture>` would be redundant here: the choice is already made in markup
 * by rendering either the mobile or the desktop carousel, and `useGlobal`
 * resolves that from the user agent during SSR rather than from a measured
 * width.
 */
export const CarouselBackground: React.FC<CarouselBackgroundProps> = ({
  src,
  isMobile,
  mobileAspectRatio,
  desktopAspectRatio,
  priority = false,
}) => (
  <CategoryBlockBackgroundImage
    priority={priority}
    mobile={
      isMobile
        ? {
            src,
            aspectRatio: mobileAspectRatio,
            sizes: BLOCK_SIZES_MOBILE,
            widths: BLOCK_WIDTHS_MOBILE,
          }
        : {
            src,
            aspectRatio: desktopAspectRatio,
            sizes: BLOCK_SIZES_DESKTOP,
            widths: BLOCK_WIDTHS_DESKTOP,
          }
    }
  />
);
